import React from 'react';
import HearthcrawlLanding from './components/HearthcrawlLanding';
import './index.css';

function App() {
  return (
    <div className="App">
      <HearthcrawlLanding />
    </div>
  );
}

export default App;